"use client"

import { Col, Row } from "antd"
import FormSearchFlight from "../SearchFlightsDesktop/FormSearchFlight"
import Title from "@/components/common/Typography/Title"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import DrawerFormSearchFlight from "../../FormSearch/mobile/DrawerFormSearchFlight"
import { FlightSearchPrefill } from "./flightSearchPrefill"

const FlightSearchBox = ({
  prefill,
  titleLevel = 3,
}: {
  prefill?: FlightSearchPrefill
  titleLevel?: 1 | 2 | 3 | 4 | 5
}) => {
  const isDesktop = useIsDesktop()
  
  if (!isDesktop) {
    return <DrawerFormSearchFlight autoHeight prefill={prefill} />
  }

  return (
    <Row
      justify='center'
      style={{
        paddingBlock: '6rem',
        marginBottom: '4rem',
        backgroundImage: `url("/static/images/bg-ve-may-bay.png")`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center'
      }}
    >
      <Col span={24} className="flight__search-box--container">
        <Title style={{ margin: 0, marginBottom: '0.5rem', color: '#ffffff' }} level={titleLevel}>
          Vé máy bay
        </Title>
      </Col>
      <Col span={24}>
        <FormSearchFlight fixedPosition={false} prefill={prefill} />
      </Col>
    </Row>
  )
}

export default FlightSearchBox